module.exports = __webpack_public_path__ + "img/otopack-250-active.199e0461.svg";